export default "__VITE_ASSET__3fde3083__"